import { render, staticRenderFns } from "./FbCarouselLayout.vue?vue&type=template&id=2df3f74e&scoped=true&"
import script from "./FbCarouselLayout.vue?vue&type=script&lang=js&"
export * from "./FbCarouselLayout.vue?vue&type=script&lang=js&"
import style0 from "./FbCarouselLayout.vue?vue&type=style&index=0&id=2df3f74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df3f74e",
  null
  
)

export default component.exports